<app-patient-subscriptions-data-table
  #subscriptionsDataTable
  [loadSubscriptions]="loadSubscriptions"
  (onViewEdit)="onView($event)"
  [patientView]="true"
></app-patient-subscriptions-data-table>
